<div class="mx-auto grid max-w-[900px] gap-4 p-4 text-slate-900">

  <a routerLink="/dashboard" class="text-[13px] text-slate-600">&larr; Dashboard</a>

  <h1 class="m-0 text-xl font-bold">Admin</h1>

  <ul class="m-0 grid list-none gap-3 p-0">
    @for (page of pages; track page.route) {
      <li class="grid gap-0.5">
        <a [routerLink]="page.route" class="text-[15px] font-semibold">{{ page.title }}</a>
        <code class="text-[11px] text-slate-500">/energy-admin/{{ page.route }}</code>
      </li>
    }
  </ul>
</div>
